import { render, staticRenderFns } from "./Platin360.vue?vue&type=template&id=876e35e8&scoped=true"
import script from "./Platin360.vue?vue&type=script&lang=js"
export * from "./Platin360.vue?vue&type=script&lang=js"
import style0 from "./Platin360.vue?vue&type=style&index=0&id=876e35e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876e35e8",
  null
  
)

export default component.exports